<template>
  <div class="alpha-scattering-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F = k · (Z_e · 2e) / r²$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Gold Nucleus -->
          <circle cx="200" cy="120" r="15" fill="#ffd700">
             <animate attributeName="r" values="14;16;14" dur="2s" repeatCount="indefinite" />
          </circle>
          <text x="180" y="150" fill="#ffd700" font-size="10">金原子核</text>

          <!-- Alpha Particles -->
          <g v-for="p in particles" :key="p.id">
            <circle :cx="p.x" :cy="p.y" r="3" fill="#ff4757" v-if="p.active" />
            <!-- Trail -->
            <path v-if="p.active && p.trail.length > 2" :d="renderTrail(p)" fill="none" stroke="#ff4757" stroke-width="0.5" opacity="0.4" />
          </g>

          <!-- Observation Screeen (Circular) -->
          <circle cx="200" cy="120" r="115" fill="none" stroke="rgba(255,255,255,0.1)" stroke-dasharray="4" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>绝大多数粒子几乎不偏转</label>
              <div class="value">少数发生大角度偏转：核子模型证据</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-button type="primary" size="mini" @click="emitBatch">发射 α 粒子束</el-button>
             <el-button size="mini" @click="clear">清除路径</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>卢瑟福通过观察 α 粒子穿过金箔后的偏转发现，极少数粒子甚至被**原路弹回**。这说明原子中心存在一个体积极小但占据绝大部分质量、带正电的**原子核**。这一实验彻底否定了汤姆孙的“布丁模型”。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlphaScatteringViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      particles: [],
      timer: null
    }
  },
  methods: {
    emitBatch() {
      for (let i = 0; i < 5; i++) {
        this.particles.push({
          id: Date.now() + i,
          x: 20,
          y: 60 + Math.random() * 120, // Distributed along the axis
          vx: 5,
          vy: 0,
          trail: [],
          active: true
        });
      }
      if (!this.timer) this.update();
    },
    clear() { this.particles = []; },
    renderTrail(p) {
      if (p.trail.length < 2) return "";
      return "M " + p.trail.map(t => `${t.x} ${t.y}`).join(" L ");
    },
    update() {
      this.particles.forEach(p => {
        if (!p.active) return;
        
        // Coulomb Force: F = k*q1*q2 / r^2
        let dx = p.x - 200;
        let dy = p.y - 120;
        let r2 = dx*dx + dy*dy;
        let r = Math.sqrt(r2);
        
        if (r > 5) {
          let force = 4000 / r2; // Simplified force constant
          let ax = force * (dx / r);
          let ay = force * (dy / r);
          p.vx += ax;
          p.vy += ay;
        }

        p.x += p.vx;
        p.y += p.vy;
        p.trail.push({ x: p.x, y: p.y });

        // Boundaries
        if (p.x < 0 || p.x > 400 || p.y < 0 || p.y > 240) {
          p.active = false;
        }
      });

      this.timer = requestAnimationFrame(this.update);
    }
  },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.alpha-scattering-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #001; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
